import React, { Component } from 'react';

//componentes
import NotaCredito from './notaCreditoP'

class Index extends Component {

    render(){
        return(
            <div>
                <NotaCredito />
            </div>
        );
    }

}
export default Index;